import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { DeleteProfessionalInformationFields } from '../types/SharedActions';

import { updateLocalStorage } from './updateLocalStorage';

export const deleteProfessionalInformationFields = (
  doc: CoverLetterDocumentType,
  value: DeleteProfessionalInformationFields['value']
): void => {
  const professionalExperiences = [
    ...(doc.professionalExperience ?? []),
  ].filter((_, index) => index !== value);

  updateLocalStorage(`professionalExperience`, professionalExperiences);
};
